import $i18n from 'panda-i18n';

const defaultMenuList = [
  {
    label: $i18n.get({ id: 'Home.four_px', dm: '首页' }),
    value: 'index',
    path: '/',
  },

  {
    label: $i18n.get({ id: 'Order.four_px', dm: '订单' }),
    value: 'order',
    path: '/order/inboundorder',
  },

  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: 'inbound',
    path: '/inbound/ReceivingPlan/list',
  },

  {
    label: $i18n.get({ id: 'InTheDatabase.four_px', dm: '库内' }),
    value: 'inside',
    path: '/inside/MoveKu/list',
  },

  {
    label: $i18n.get({ id: 'CheckedOut.four_px', dm: '出库' }),
    value: 'outbound',
    path: '/outbound/pick/manualRemit/list',
  },

  {
    label: $i18n.get({ id: 'TJ.Return.four_px', dm: '退件' }),
    value: 'returnService',
    path: '/returnService/ReturnCheck/plantList',
  },

  {
    label: $i18n.get({ id: 'Product.four_px', dm: '商品' }),
    value: 'goods',
    path: '/goods/message/stockmessage',
  },

  // {
  //   label: '客户',
  //   value: 'client',
  //   path: '/client/list',
  // },
  // {
  //   label: '报表',
  //   value: 'report',
  //   path: '/report/list',
  // },
  {
    label: $i18n.get({ id: 'Base.four_px', dm: '基础' }),
    value: 'basedata',
    path: '/basedata/containermanage',
  },

  {
    label: 'AGV',
    value: 'automation',
    path: '/automation/automation/list',
  },

  {
    label: $i18n.get({ id: 'Report.four_px', dm: '报表' }),
    value: 'service',
    path: '/service/outbound/billboard',
  },

  {
    label: $i18n.get({ id: 'Allocation.four_px', dm: '分拨' }),
    value: 'allocate',
    path: '/allocate/parcelOrder/list',
  },

  {
    label: 'FBA',
    value: 'fba',
    path: '/fba/consignment/list',
  },

  {
    label: $i18n.get({ id: 'dev', dm: '开发' }),
    value: 'dev',
    path: '/dev/monitor/outbound',
  },
];

const otherMenuList = [
  {
    label: $i18n.get({ id: 'Home.four_px', dm: '首页' }),
    value: 'index',
    path: '/',
  },

  {
    label: $i18n.get({ id: 'Order.four_px', dm: '订单' }),
    value: 'order',
    path: '/order/inboundorder',
  },

  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: 'inbound',
    path: '/inbound/ReceivingPlan/list',
  },

  {
    label: $i18n.get({ id: 'InTheDatabase.four_px', dm: '库内' }),
    value: 'inside',
    path: '/inside/MoveKu/list',
  },

  {
    label: $i18n.get({ id: 'CheckedOut.four_px', dm: '出库' }),
    value: 'outbound',
    path: '/outbound/pick/manualRemit/list',
  },

  {
    label: $i18n.get({ id: 'Product.four_px', dm: '商品' }),
    value: 'goods',
    path: '/goods/message/stockmessage',
  },

  {
    label: $i18n.get({ id: 'Base.four_px', dm: '基础' }),
    value: 'basedata',
    path: '/basedata/containermanage',
  },

  {
    label: 'AGV',
    value: 'automation',
    path: '/automation/automation/list',
  },

  {
    label: $i18n.get({ id: 'Report.four_px', dm: '报表' }),
    value: 'service',
    path: '/service/inbound/billboard',
  },

  {
    label: $i18n.get({ id: 'Surveillance.four_px', dm: '监控' }),
    value: 'monitor',
    path: '/monitor/outbound',
  },
];

export { defaultMenuList, otherMenuList };
